import Vue from 'vue'

Vue.directive('textareaAutoHeight', {
  update(elem) {
    elem.style.height = '1px'
    elem.style.height = elem.scrollHeight + 'px'
  }
})
